const en = {
  en: {
    translation: {
      document: {
        attachment: 'Attachment:',
        cc: 'Cc:',
        email_account: 'Email account:',
        email_ref: 'Email reference: ',
        folder: 'Folder:',
        from: 'From:',
        id: 'Id:',
        language: 'Language:',
        message_id: 'Message Id:',
        mime: 'Mime:',
        modified_user: 'Modified by:',
        reception_date: 'Reception date:',
        scope: 'Scope:',
        send_date: 'Send date:',
        to: 'To:',
        type_document: {
          attachment: 'Attachment',
          email: 'Email',
          libelle: 'Type of document:',
        },
        type_scope: {
          back_up: 'BackUp',
          irrelevant: 'Irrelevant',
          other: 'Other',
          personal: 'Personal',
          relevant: 'Relevant',
          unexploited: 'Unexploited',
          very_relevant: 'Very Relevant',
        },
      },
    },
  },
};

export default en;
